import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  selector: 'qaroni-label-phone-preview',
  templateUrl: './label-phone-preview.component.html',
  styleUrls: ['./label-phone-preview.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class LabelPhonePreviewComponent {
  readonly phone = input<string>('');
  readonly label = input<boolean>(false);
}
